import React from 'react';
import { Divider as DividerComponent } from '../../../divider/Divider';

export const Divider = ({ data, ...rest }) => (
  <DividerComponent {...data} {...rest} />
);
